module.exports = __webpack_public_path__ + "static/media/example-nps.e4300074.csv";